import React from "react";
import SurveyForm from "../SurveyForm";

function Index({ config }) {
  const items = [
    {
      id: 1,
      name: "Select a survey type",
      options: [
        {
          id: 1,
          label: "Unit CSD without Survey Information - Base Fee",
          price: config.useNewFees ? 422.0 : 310.0,
        },
        {
          id: 2,
          label: "Unit CSD with Survey Information - Base Fee",
          price: config.useNewFees ? 1130.0 : 850.0,
        },
      ],
      maxQuantity: 100,
      fixedQuantity: (item) => {
        return null;
      },
      isEnabled: (item) => {
        return true;
      },
    },
    {
      id: 2,
      name: "Parcel defined by a Permanent Structure Boundary (Principal and accessory units)",
      price: config.useNewFees ? 112.0 : 75.0,
      maxQuantity: 500,
      fixedQuantity: (item) => {
        return null;
      },
      isEnabled: (item) => {
        return true;
      },
    },
    {
      id: 3,
      name: "Non Primary Parcels (new easement and land covenant parcels)",
      price: config.useNewFees ? 80.0 : 60.0,
      maxQuantity: 500,
      fixedQuantity: (item) => {
        return null;
      },
      isEnabled: (item) => {
        return true;
      },
    },
    {
      id: 4,
      name: "Deposit fee",
      price: config.useNewFees ? 182.0 : 150.0,
      maxQuantity: 100,
      fixedQuantity: (item) => {
        return 1;
      },
      isEnabled: (item) => {
        return false;
      },
    },
  ];

  const model = {
    items: items,
    depositFeesId: 4,
    enableModal: true,
    getDepositFeeQuantity: (option, planType) => {
      if (!option) return 0;

      return 1;
    },
  };

  return <SurveyForm title="Unit CSD Fee Calculator" data={model} />;
}

export default Index;
